/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Jun 22 2023
 **/

import styled from "@emotion/styled";

import { ZIndex } from "@/frameworks/core/commons";
import { Column, Row } from "@/frameworks/designStuff/components";

export const InputForm = styled(Column.form)`
	position: relative;
	z-index: 1;
	width: 100%;
	border-radius: 12px;
	background: ${({ theme }) => theme.colors.neutral_00_80};
	backdrop-filter: blur(10px);
`;

export const Layout = styled(Column)<{ isShowMarkImage?: boolean }>`
	position: fixed;
	right: 12px;
	bottom: 12px;
	width: 278px;
	max-height: calc(100% - 60px - 45px);
	overflow: hidden;
	mask-image: ${({ isShowMarkImage }) =>
		isShowMarkImage ? "linear-gradient(to top, #fff 84%, transparent 92%)" : "none"};
	z-index: ${ZIndex.TRANSPARENT_CHAT};
	&::-webkit-scrollbar {
		display: none;
	}
`;

export const ChatRoomSelectButton = styled(Row)<{ isAudioZone: boolean; isMeeting?: boolean }>`
	padding: 8px 12px;
	height: 44px;
	width: 100%;
	background: ${({ isAudioZone, theme }) => (isAudioZone ? theme.colors.accent_20_100 : theme.colors.neutral_80_32)};
	border-radius: 12px;
	cursor: ${({ isMeeting }) => (isMeeting ? "none" : "pointer")};
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const VerticalDividerStyled = styled.div`
	height: 24px;
	margin: 0 8px;
	border-right: 1px solid ${({ theme }) => theme.colors.neutral_00_32};
`;

export const BadgeStyled = styled.div`
	width: 12px;
	height: 12px;
	border-radius: 12px;
	background: ${({ theme }) => theme.colors.error_60_100};
	border: 1px solid ${({ theme }) => theme.colors.neutral_00_100};
	position: absolute;
	top: 0;
	left: 0;
`;
